var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 149 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3020_369534)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.5537 15.7692C61.7605 15.7692 52.2002 25.3004 52.2002 37.0577V69.8577C52.2002 81.615 61.7605 91.1461 73.5537 91.1461C85.3469 91.1461 94.9072 81.615 94.9072 69.8577V37.0577C94.9072 25.3004 85.3469 15.7692 73.5537 15.7692ZM36.3828 37.0577C36.3828 16.5913 53.0248 0 73.5537 0C94.0827 0 110.725 16.5913 110.725 37.0577V69.8577C110.725 90.3241 94.0827 106.915 73.5537 106.915C53.0248 106.915 36.3828 90.3241 36.3828 69.8577V37.0577Z",
    fill: "#BD4F51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.933 48.5684H34.1623C28.9209 48.5684 24.6719 52.8044 24.6719 58.0299V113.538C24.6719 118.763 28.9209 122.999 34.1623 122.999H112.933C118.174 122.999 122.423 118.763 122.423 113.538V58.0299C122.423 52.8044 118.174 48.5684 112.933 48.5684Z",
    fill: "#BD4F51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.933 48.5684H34.1623C28.9209 48.5684 24.6719 52.8044 24.6719 58.0299V106.915C24.6719 112.14 28.9209 116.376 34.1623 116.376H112.933C118.174 116.376 122.423 112.14 122.423 106.915V58.0299C122.423 52.8044 118.174 48.5684 112.933 48.5684Z",
    fill: "#EB5757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.372 64.5002C145.372 81.343 131.635 95.0004 114.686 95.0004C97.7362 95.0004 84 81.343 84 64.5002C84 47.6577 97.7362 34 114.686 34C131.635 34 145.372 47.6577 145.372 64.5002Z",
    fill: "white",
    stroke: "#E5E8EB",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.349 66.7571C112.146 69.9462 116.692 69.9462 117.489 66.7571L121.649 50.0997C122.146 48.1096 120.636 46.1836 118.579 46.1836H110.259C108.202 46.1836 106.692 48.1096 107.189 50.0997L111.349 66.7571Z",
    fill: "#EB5757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.528 84.1102C117.404 84.1102 119.736 81.7858 119.736 78.9184C119.736 76.051 117.404 73.7266 114.528 73.7266C111.652 73.7266 109.32 76.051 109.32 78.9184C109.32 81.7858 111.652 84.1102 114.528 84.1102Z",
    fill: "#EB5757"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3020_369534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 149,
    height: 123,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockAccount);
export default __webpack_public_path__ + "static/media/lock-account.a21a16cddb65f9d59d58a81c661b5da6.svg";
export { ForwardRef as ReactComponent };